import { render, staticRenderFns } from "./Menus.vue?vue&type=template&id=568d9427&scoped=true&lang=true&"
import script from "./Menus.vue?vue&type=script&lang=js&"
export * from "./Menus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d9427",
  null
  
)

export default component.exports